var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Test webpay")]),_c('HotelDatePicker',{attrs:{"disabledDates":['2019-11-14', '2019-10-15' ]}}),_c('a',{attrs:{"href":_vm.url}},[_vm._v("pagar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }